import { PaytrieAPI } from '@paytrie/client'

import { MagicLinkUnauthorizedError } from './MagicLinkUnauthorizedError'

export const denyMagicLink = async ({
  email,
  verifier,
}: {
  email: string
  verifier: string
}): Promise<void> => {
  const response = await PaytrieAPI.denyMagicLink(verifier, {
    email,
  })

  if (response.status === 401) throw new MagicLinkUnauthorizedError()
  if (response.status !== 204) {
    throw new Error(`Magic link deny failed (status ${response.status})`)
  }
}
